if (!customElements.get("career-department")) {
  class CareerDepartment extends HTMLElement {
    constructor() {
      super();
      this.modal = null;
      this.success = null;
      this.form = null;
      this.formElement = null;
      this.selectedRole = null;
      this.loading = null;
      this.label = null;
      this.opener = null;
      this._focusTrap = null;
      this.onOpen = this.onOpen.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.modal = this.querySelector("[data-apply-modal]");
      this.backdrop = this.querySelector("[data-apply-modal] [data-close-apply]");
      this.success = this.querySelector("[data-apply-success]");
      this.form = this.querySelector("[data-apply-form]");
      this.formElement = this.querySelector("[data-apply-form-element]");
      this.selectedRole = this.querySelector("[data-selected-role]");
      this.selectedRoleInput = this.querySelector("[data-selected-role-input]");
      this.loading = this.querySelector("[data-submit-loading]");
      this.label = this.querySelector("[data-submit-label]");

      this.querySelectorAll("[data-open-apply]").forEach((button) => {
        button.addEventListener("click", this.onOpen);
      });
      this.querySelectorAll("[data-close-apply]").forEach((button) => {
        button.addEventListener("click", this.onClose);
      });
      this.formElement?.addEventListener("submit", this.onSubmit);
    }

    disconnectedCallback() {
      this.querySelectorAll("[data-open-apply]").forEach((button) => {
        button.removeEventListener("click", this.onOpen);
      });
      this.querySelectorAll("[data-close-apply]").forEach((button) => {
        button.removeEventListener("click", this.onClose);
      });
      this.formElement?.removeEventListener("submit", this.onSubmit);
    }

    onOpen(event) {
      if (!this.modal) return;
      this.opener = event.currentTarget;
      const role = event.currentTarget.getAttribute("data-role-title") || "Role";
      if (this.selectedRole) {
        this.selectedRole.textContent = role;
      }
      if (this.selectedRoleInput) {
        this.selectedRoleInput.value = role;
      }
      this.showForm();
      this.modal.classList.remove("hidden");
      this.modal.classList.add("flex");
      this.modal.setAttribute("data-open", "true");
      this.modal.setAttribute("aria-hidden", "false");
      this.backdrop?.classList.add("opacity-100");
      document.documentElement.classList.add("overflow-hidden");

      // Focus trap
      this._focusTrap = webvista.createFocusTrap(this.modal, {
        onEscape: () => this.onClose(),
      });
      this.modal.addEventListener("keydown", this._focusTrap);

      // Auto-focus first focusable element
      webvista.focusFirstElement(this.modal);
    }

    onClose() {
      if (!this.modal) return;

      // Remove focus trap
      if (this._focusTrap) {
        this.modal.removeEventListener("keydown", this._focusTrap);
        this._focusTrap = null;
      }

      this.backdrop?.classList.remove("opacity-100");
      this.modal.classList.remove("flex");
      this.modal.classList.add("hidden");
      this.modal.removeAttribute("data-open");
      this.modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("overflow-hidden");
      this.resetForm();

      // Return focus to opener
      if (this.opener) {
        this.opener.focus();
        this.opener = null;
      }
    }

    onSubmit(event) {
      event.preventDefault();
      const submitButton = this.querySelector("[data-apply-submit]");
      submitButton?.setAttribute("disabled", "true");
      submitButton?.setAttribute("aria-busy", "true");
      if (this.label && this.loading) {
        this.label.classList.add("hidden");
        this.loading.classList.remove("hidden");
        this.loading.classList.add("flex");
      }

      window.setTimeout(() => {
        this.showSuccess();
        submitButton?.removeAttribute("disabled");
        submitButton?.setAttribute("aria-busy", "false");
        if (this.label && this.loading) {
          this.label.classList.remove("hidden");
          this.loading.classList.add("hidden");
          this.loading.classList.remove("flex");
        }
      }, 900);
    }

    showSuccess() {
      this.success?.classList.remove("hidden");
      this.form?.classList.add("hidden");
    }

    showForm() {
      this.success?.classList.add("hidden");
      this.form?.classList.remove("hidden");
    }

    resetForm() {
      if (!this.formElement) return;
      this.formElement.reset();
      this.showForm();
    }
  }

  customElements.define("career-department", CareerDepartment);
}
